import { makeActionCreator } from '../../../utilities'
import { ZollApiConstants } from './zollApi.constants'

export const throwApiException = makeActionCreator(ZollApiConstants.THROW_API_EXCEPTION, 'exception')
